/**
 * Created by Owner on 2016/8/1.
 */
import {AlertController, ToastController} from 'ionic-angular';

export class AppDialog {
    static alert(opts?: DialogOptions) {
        let alertCmp = opts.alertCtrl.create({
            title: '',
            subTitle: opts.message,
            enableBackdropDismiss: false,
            buttons: [{
                text: 'OK',
                handler: () => {
                    if (opts.callBack) {
                        opts.callBack();
                    }
                }
            }]
        });
        if (opts.fn) {
            alertCmp.present().then(opts.fn);
        } else {
            alertCmp.present().then();
        }
    };

    static toast(opts?: ToastOptions) {
        let toast = opts.toastCtrl.create({
            message: opts.message,
            duration: 2000,
            position: 'bottom'
        });
        if (opts.fn) {
            toast.present().then(opts.fn);
        } else {
            toast.present();
        }
    }
}

export interface DialogOptions {
    alertCtrl: AlertController,
    fn?: any,
    message?: string;
    callBack?: any;
}

export interface ToastOptions {
    toastCtrl: ToastController,
    fn?: any,
    message?: string;
}




// WEBPACK FOOTER //
// ./src/component/appDialog.ts